export { allowedVideoFileExtensions as supportedVideoExtensions } from '@bingads-webui-campaign-react/upload-file-picker';

export const CSMLAdTypeUsage = {
  UsedIn: 'Used in',
  NotUsedIn: 'Not used in',
};

export const CSMLAdType = {
  MMA: 'Multimedia ad',
  Audience: 'Microsoft Advertising Network',
  ImageExtension: 'Image extension',
};

export const CSMLSortBy = {
  ImageName: 'Image name',
  ImageNameDesc: 'Image name (Z-A)',
  MostRecent: 'Most recent',
  MostRecentAsc: 'Most recent asc',
  LastCreated: 'Last created',
  LastCreatedAsc: 'Last created asc',

  AssetIdAsc: 'Asset Id Asc',
  AssetIdDesc: 'Asset Id Desc',

  ClickAsc: 'Click Asc',
  ClickDesc: 'Click Desc',
  ClickPeriodAsc: 'Period Click Asc',
  ClickPeriodDesc: 'Period Click Desc',
  ClickChangeAsc: 'Click Change Asc',
  ClickChangeDesc: 'Click Change Desc',
  ClickChangePercentAsc: 'Click Change Percent Asc',
  ClickChangePercentDesc: 'Click Change Percent Desc',

  CTRAsc: 'CTR Asc',
  CTRDesc: 'CTR Desc',
  CTRPeriodAsc: 'Period CTR Asc',
  CTRPeriodDesc: 'Period CTR Desc',
  CTRChangeAsc: 'CTR Change Asc',
  CTRChangeDesc: 'CTR Change Desc',
  CTRChangePercentAsc: 'CTR Change Percent Asc',
  CTRChangePercentDesc: 'CTR Change Percent Desc',

  ImpressionAsc: 'Impression Asc',
  ImpressionDesc: 'Impression Desc',
  ImpressionPeriodAsc: 'Period Impression Asc',
  ImpressionPeriodDesc: 'Period Impression Desc',
  ImpressionChangeAsc: 'Impression Change Asc',
  ImpressionChangeDesc: 'Impression Change Desc',
  ImpressionChangePercentAsc: 'Impression Change Percent Asc',
  ImpressionChangePercentDesc: 'Impression Change Percent Desc',

  SpendAsc: 'Spend Asc',
  SpendDesc: 'Spend Desc',
  SpendPeriodAsc: 'Period Spend Asc',
  SpendPeriodDesc: 'Period Spend Desc',
  SpendChangeAsc: 'Spend Change Asc',
  SpendChangeDesc: 'Spend Change Desc',
  SpendChangePercentAsc: 'Spend Change Percent Asc',
  SpendChangePercentDesc: 'Spend Change Percent Desc',
};

export const CSMLTimeFrame = {
  Anytime: 'Anytime',
  Today: 'Today',
  Last7Days: 'Last 7 days',
  Last30Days: 'Last 30 days',
  Custom: 'Custom range',
};

export const CSMLImportSource = {
  Google: 'Google',
  Facebook: 'Facebook',
};

export const CSMLAssetSource = {
  UserUploaded: 'UserUploaded',
  AIGenerated: 'AIGenerated',
  Website: 'WebsiteImported',
  Shutterstock: 'ShutterStock',
  Facebook: 'FacebookImported',
  Google: 'GoogleImported',
  BackgroundChangeGenerated: 'BackgroundChangeGenerated',
  AIGeneratedByRecraft: 'AIGeneratedByRecraft',
};

export const AIModelSource = {
  Dalle: 'Dalle',
  Recraft: 'Recraft',
};

export const DEFAULT_PAGE_SIZE = 20;

export const MIN_SIZE = [
  703, // width
  368, // height
];

export const UPSCALE_MIN_SIZE = [ // half of MIN_SIZE
  352, // width
  184, // height
];

export const CROP_BOX_MAX_SIZE = {
  width: 416,
  height: 300,
};

export const CSMLAdTypeAbbr = {
  [CSMLAdType.MMA]: 'MultiMediaAd',
  [CSMLAdType.Audience]: 'MSAN',
  [CSMLAdType.ImageExtension]: 'ImageExtension',
};

// deprecated after folder pilot is Ga-ed
// export const CSMLCalloutPreferenceFlag = 'WebApp.CampaignUI.ShowAssetLibraryCallout';

export const CSMLFoldersCalloutPreferenceFlag = 'WebApp.CampaignUI.ShowAssetLibraryFoldersCallout';

export const CalloutDisplayPeriod = {
  AfterClickClose: 4,
  AfterClickCancelButton: 2,
};

export const ClarityTags = {
  LaunchedAssetLibrary: 'LaunchedAssetLibrary',

  // begin: will deprecate in v3 pilot
  LaunchedAddAssetsFromAssetLibrary: 'LaunchedAddAssetsFromAssetLibrary',
  // end
  LaunchedUploadAssetsFromAssetLibrary: 'LaunchedUploadAssetsFromAssetLibrary',
  LaunchedAddImageAssetsFromAssetLibrary: 'LaunchedAddImageAssetsFromAssetLibrary',
  LaunchedAddVideoAssetsFromAssetLibrary: 'LaunchedAddVideoAssetsFromAssetLibrary',
  LaunchedAddAssetsFromCrudAd: 'LaunchedAddAssetsFromCrudAd',

  LaunchedEditImage: 'LaunchedEditImage',

  LaunchedImageDetails: 'LaunchedImageDetails',
  LaunchedVideoDetails: 'LaunchedVideoDetails',
};

export const ROOT_FOLDER_ID = 'ROOT';

export const FolderAssetType = {
  Image: 'Image',
  Video: 'Video',
};

export const RootFolderName = {
  [FolderAssetType.Image]: _TL_('Images'),
  [FolderAssetType.Video]: _TL_('Videos'),
};

export const isRootFolderId = folderIdToTest => folderIdToTest === ROOT_FOLDER_ID;

export const supportedImageExtensions = ['.png', '.jpg', '.jpeg', '.gif'];

export const GridSectionName = {
  Folder: 'folderSection',
  Asset: 'assetsSection',
};

export const MaxAddAssetJobInParell = 6;

export const AssetLibraryAppNameODataHeader = {
  key: 'x-ms-applicationname',
  value: 'bingadsweb-assetlibrary',
};

export const CSMLSearchLocation = {
  Current: 'Current',
  Global: 'Global',
};

export const VideoStatus = {
  Unverified: 'Unverified',
  Draft: 'Draft',
  Active: 'Active',
  Failed: 'Failed',
  Transcoding: 'Transcoding',
};

// important! do not change the name for each page since they are used in our report
export const PageNameForLog = {
  Landing: 'LandingPage',
  ImageDetails: 'ImageDetailsPage',
  ImageEditing: 'ImageEditingPage',
  AddLocalAssets: 'AddLocalAssetsPage',
  AddLocalFolder: 'AddLocalFolderPage',
  AddImage: 'AddImagePage',
  AddImageFolder: 'AddImageFolderPage', // Only used in V2, V3 has a new route for upload folder (AddLocalFolder)
  VideoDetails: 'VideoDetailsPage',
  AddVideo: 'AddVideoPage',
  Performance: 'PerformancePage',
};

export const VersionForLog = {
  V3: 'V3',
  V4: 'V4',
  V5: 'V5', // AIGC
};

export const RealUsedFlagSuffix = {
  App: 'AssetLibraryApp',
  Picker: 'AssetLibraryPicker',
  PerfTable: 'AssetLibraryPerfTableView',
  AIGCMVP: 'AssetLibraryAIGCMVPView',
};

export const AssetLibrarySurveyTriggerFlag = {
  App: 'AssetLibraryAppSurveyTrigger',
  Picker: 'AssetLibraryPickerSurveyTrigger',
  AIGCMVP: 'AssetLibraryAIGCMVPSurveyTrigger',
};

export const AssetLibraryPageName = {
  LandingPage: 'LandingPage',
  PerfPage: 'PerfPage',
};
